module.exports = __webpack_public_path__ + "img/sa.d2d27d20.svg";